<template>
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="bg--color"
        dark
      >
        <v-card-text>
          {{message}}
          <v-progress-linear
            indeterminate height="2"
            color="white"
            class="mb-0"  
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
/**
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
  name: "loader",
  data() {
    return {
      dialog: false,
      resolve: null,
      message: null,
      title: null,
      options: {
        color: "error",
        width: 350
      }
    };
  },
  methods: {
    start(msg, options) {
      this.dialog = true;
      this.change(msg);
      this.options = Object.assign(this.options, options);
    },
    change(msg) {
      this.message = msg || "Please stand by";
    },
    stop() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.bg--color {
  background-color: #0d7e83 !important;
}
</style>
